/**
 * Every string this surface renders, transcribed from the pack verbatim.
 *
 * The «what was unaffected» sentence is operator-scoped, and that is the whole
 * difference from the same page on the two sibling hosts: a subscriber is
 * reassured about their account, their subscription, and their list. An operator
 * fears that the catalogue or a queue moved, or that an action ran — so the
 * sentence names those and denies them.
 *
 * No status numeral, no technical vocabulary, and no restatement of a mechanic
 * the screen already performs.
 */
export const copy = {
  /** Tab identification only — this host is `noindex, nofollow` everywhere. */
  documentTitle: 'الصفحة غير موجودة — وحدة تحكّم شاهدني',

  heading: 'هذا السطح لم يعد موجوداً',

  body: 'قد يكون العنوان الذي وصلت منه قديماً، أو أن السطح الذي تبحث عنه غادر هذه الوحدة. لم يتغيّر شيء في الفهرس ولا في الطوابير، ولم يُنفَّذ أي فعل، وبقيّة أسطح التشغيل تعمل كالمعتاد.',

  actions: {
    home: 'عد إلى لوحة التشغيل',
    /**
     * The content list, not public search: a failed operator URL is usually a
     * work URL, and the content list is the only surface here that shows titles
     * in every publish state. A draft does not appear in
     * public search at all.
     */
    content: 'افتح قائمة المحتوى',
  },
} as const;
